import errorManager from '@/rollbar.js';

const changeAutoformCod = (event) => {
  const selected = event.target.options[event.target.selectedIndex];
  const cod = selected.getAttribute('cod');
  const pdmiTraigeTable = document.querySelector('#pdmi_triage_table');
  pdmiTraigeTable?.classList.add('hide');
  eventBus.$emit('changeAutoformCod', cod);
  const check_input = document.querySelectorAll('#guest_event_tipo_evento_av, #guest_event_evento_avverso, #guest_event_evento_sentinella');
  check_input.forEach((ci) => (ci.checked = false));
  if (/avverso/i.test(cod)) {
    document.querySelectorAll('#guest_event_tipo_evento_av, #guest_event_evento_avverso').forEach((ci) => (ci.checked = true));
  } else if (/sentinella/i.test(cod)) {
    check_input.forEach((ci) => (ci.checked = true));
  } else if (/pdmi_triage/i.test(cod)) {
    pdmiTraigeTable.classList.remove('hide');
  }
};

const updateDuration = (eventSelector, dateEventSelector, dateEndSelector, businessUnitId, getDurationUrl) => {
  $.ajax({
    url: getDurationUrl,
    data: { business_unit_id: businessUnitId, event_id: $(eventSelector).val() },
    dataType: 'json',
    success: function (response) {
      var event_duration = response.value;
      var event_date = $(dateEventSelector).val();
      var event_end_date = moment(event_date, 'DD/MM/YYYY').add(event_duration, 'days').format('DD/MM/YYYY');
      $(dateEndSelector).val(event_end_date);
    },
    error: function (e) {
      console.log(e);
    },
  });
};

const setListener = (eventSelector, dateEventSelector, dateEndSelector, durationEnabled, businessUnitId, getDurationUrl, function_name) => {
  $(eventSelector).on('change', function (e) {
    if (durationEnabled) {
      updateDuration(eventSelector, dateEventSelector, dateEndSelector, businessUnitId, getDurationUrl);
    }

    switch (function_name) {
      case 'changeAutoformCod':
        changeAutoformCod(e);
        break;
    }
  });

  $(dateEventSelector).on('change', function (e) {
    if (durationEnabled) {
      updateDuration(eventSelector, dateEventSelector, dateEndSelector, businessUnitId, getDurationUrl);
    }
  });
};

const init = (eventSelector, dateEventSelector, dateEndSelector, durationEnabled, businessUnitId, getDurationUrl, function_name) => {
  try {
    setListener(eventSelector, dateEventSelector, dateEndSelector, durationEnabled, businessUnitId, getDurationUrl, function_name);
  } catch (e) {
    errorManager(e);
  }
};

window.GuestEvent = {
  init: init,
};
